import {Fonts} from "@/constants/font";
import BBCodeText from "phaser3-rex-plugins/plugins/bbcodetext";
import {Keys} from "@/constants/key";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "../utils/c-u";

export class ListManualPanel extends Phaser.GameObjects.Container {

    static readonly MIRROR_CREATURES: string[] = [
        'us-dog', 'elite-dragon-3', 'elite-unicorn', 'elite-dragon', 'ht-dragon', 'ht-serpent', 'top-angel', 'who-4',
        'of_titan_1', 'of_titan_2', 'p6_epic_cyclop', 'p6_epic_shadow_1', 'p6_super_sphinx_1', 'p6_young_sphinx'];

    static readonly SHOP_CREATURES: string[] = [
        'elite-dragon-3', 'elite-unicorn', 'elite-dragon', 'elite-knight',
        'elite-mage', 'elite-golem', 'elite-dragon-2', 'elite-phoenix', 'elite-dragon-4',
        'us-dog', 'us-golem', 'us-mag', 'us-dragon',
        'leg-druid', 'leg-golem', 'leg-mag', 'leg-witch',
        'myth-mag', 'myth-phoenix', 'myth-warlock', 'myth-dragon', 'myth-warlock-2',
        'titan-1', 'titan-2', 'titan-3', 'titan-4', 'titan-5',
        'ht-dragon', 'ht-witch', 'ht-serpent', 'ht-warlock-1', 'ht-warlock-2',
        'top-angel', 'top-dragon-1', 'top-phoenix', 'top-dragon-2', 'who-1', 'who-2', 'who-3', 'who-4', 'who-5', 'who-6', 'who-7',
        'myth-angel-1', 'myth-angel-2', 'myth-angel-3', 'myth-angel-4', 'myth-angel-5',
        'myth-yot-1', 'myth-yot-2', 'myth-yot-3', 'myth-yot-4', 'myth-yot-5', 'myth-yot-6', 'myth-yot-7',
        'sur_rabbit', 'sur_sigi', 'sur_rokkara', 'sur_ns', 'am_8', 'sur_silap', 'sur_arch',
        'mon_shadow', 'mon_ifrit', 'mon_fire_1', 'mon_manti', 'mon_nun_1',
        'mon_dryad', 'mon_gorgon', 'mon_rider_1', 'mon_sukkub', 'mon_inkub', 'mon_nun_2', 'mon_rider_2', 'mon_nun_3',
        'ob_balt', 'ob_nun', 'ob_skuld', 'ob_sikji', 'ob_shadow', 'ob_serra'];

    constructor(scene: Phaser.Scene, text: string, manualId: string) {
        super(scene);

        this.scene = scene;
        this.height = ListManualPanel.getHeight(manualId);

        const back = SpriteUtils.addImage(this.scene, -300, 0, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_PANEL_BACK).setOrigin(0, 0);
        SpriteUtils.setDispSize(back, CU.CANVAS_WIDTH, this.height * CU.S);

        this.add(back);

        if (ListManualPanel.SHOP_CREATURES.includes(manualId) || manualId.startsWith('p6_') || manualId.startsWith('port_') || manualId.startsWith('of_')) {
            const creatureImage = SpriteUtils.addImage(this.scene, 200, 600, Keys.profileCreature(manualId),
                undefined, ListManualPanel.isXMirrored(manualId) ? -0.9 : 0.9, 0.9).setOrigin(0.5, 0.5);
            this.add(creatureImage);
        }

        let contentText = new BBCodeText(scene, -280 * CU.S, 0, text, {
            fontFamily: Fonts.MYRIADPRO_REGULAR,
            fontSize: '14pt',
            wrap: {
                mode: 1,
                width: 560
            },
            strokeThickness: 3
        }).setScale(CU.S, CU.S);

        this.add(contentText);
    }

    private static isXMirrored(manualId: string) {
        return ListManualPanel.MIRROR_CREATURES.includes(manualId);
    }

    private static getHeight(manualId: string) {
        if (manualId.startsWith('p6_') || manualId.startsWith('of_') || manualId.startsWith('port_')) {
            if (manualId.startsWith('p6_young')) {
                return 1500;
            }
            return 2900;
        }
        if (manualId.startsWith('ob_')) {
            if (manualId.startsWith('ob_balt')) {
                return 3420;
            }
            if (manualId.startsWith('ob_skuld')) {
                return 3600;
            }
            if (manualId.startsWith('ob_shadow')) {
                return 3400;
            }
            if (manualId.startsWith('ob_serra')) {
                return 3650;
            }
            return 3500;
        }
        if (manualId.startsWith('mon_')) {
            if (manualId.startsWith('mon_dryad')) {
                return 1140;
            }
            if (manualId.startsWith('mon_shadow') || manualId.startsWith('mon_ifrit') || manualId.startsWith('mon_fire')) {
                return 2400;
            }
            if (manualId.startsWith('mon_nun_1')) {
                return 2650;
            }
            if (manualId.startsWith('mon_nun_1')) {
                return 2650;
            }
            if (manualId.startsWith('mon_rider_1')) {
                return 2240;
            }
            if (manualId.startsWith('mon_sukkub')) {
                return 2180;
            }
            if (manualId.startsWith('mon_inkub')) {
                return 2280;
            }
            if (manualId.startsWith('mon_rider_2')) {
                return 2280;
            }
            return 2580;
        }
        switch (manualId) {
            case 'top-angel':
            case 'top-angel-b':
                return 1550;
            case 'top-phoenix':
                return 1400;
            case 'who-1':
            case 'who-3':
            case 'who-4':
            case 'who-5':
            case 'who-7':
            case 'top-dragon-1':
            case 'myth-angel-1':
            case 'myth-angel-2':
            case 'myth-angel-3':
            case 'myth-angel-4':
            case 'myth-angel-5':
            case 'am_8':
                return 1550;
            case 'who-6':
                return 1600;
            case 'myth-yot-1':
            case 'myth-yot-2':
            case 'myth-yot-3':
            case 'myth-yot-4':
            case 'myth-yot-5':
            case 'myth-yot-6':
            case 'myth-yot-7':
            case 'who-2':
            case 'top-dragon-2':
                return 1700;
            case 'bonusPoints':
                return 1200;
            case 'sur_rabbit':
            case 'sur_sigi':
                return 1400;
            case 'sur_rokkara':
                return 1500;
            case 'sur_ns':
                return 2200;
            case 'sur_silap':
            case 'sur_arch':
                return 2400;
        }
        return 700;
    }
}
